export default class formConfig {
  // 中标基本信息
  static projectInformation() {
    return [
      {
        title: "中标项目基本信息",
        name: "1",
        icon: "",
        formConfigList: [
          {
            label: "招标项目名称：",
            value: "prjName",
            type: "input",
            tip: "需录入开标记录后才能在此选择到项目。",
            width: "100%;",
            disabled: true
          },
          {
            label: "公示开始时间：",
            value: "publicityStartDate",
            type: "input",
            disabled: true,
          },
          {
            label: "公示结束时间：",
            value: "publicityEndDate",
            type: "input",
            disabled: true,
          },
          {
            label: "公示天数（天）：",
            value: "publicityDay",
            type: "input",
            disabled: true
          },
          {
            label: "招标监管部门：",
            value: "regulators",
            type: "input",
            disabled: true,
          },
          {
            label: "开标时间：",
            value: "reserveStartTime",
            type: "date",
            dateType: "datetime",
            disabled: true,
            valueFormat: "yyyy-MM-dd HH:mm",
            format: "yyyy-MM-dd HH:mm",
            popperClass: "noBtn"
          },
          {
            label: "开标地点：",
            value: "openingPlace",
            type: "input",
            disabled: true
          },
          {
            label: "评标时间：",
            value: "evaluationStartDate",
            type: "date",
            dateType: "datetime",
            disabled: true,
            valueFormat: "yyyy-MM-dd HH:mm",
            format: "yyyy-MM-dd HH:mm",
            popperClass: "noBtn"
          },
          {
            label: "评标地点：",
            value: "reviewAdd",
            type: "input",
            disabled: true
          },
          {
            label: "招标编号：",
            value: "tenderReference",
            type: "input",
            disabled: true,
          },
          {
            label: "标段号：",
            value: "section",
            type: "input",
            disabled: true,
          },
          {
            label: "建设单位（招标人）：",
            value: "tenderCorp",
            type: "input",
            width: "100%;",
            disabled: true,
          },
          {
            label: "经办人：",
            value: "person",
            type: "input",
            disabled: true
          },
          {
            label: "联系电话：",
            value: "personPhone",
            type: "input",
            disabled: true
          },
          {
            label: "招标代理机构：",
            value: "agencyCorp",
            type: "input",
            width: "100%;",
            disabled: true,
          },
          {
            label: "经办人：",
            value: "agencyCorpPerson",
            type: "input",
            disabled: true
          },
          {
            label: "联系电话：",
            value: "agencyCorpPhone",
            type: "input",
            disabled: true
          },
          {
            label: "项目名称：",
            value: "constructionPrjName",
            type: "input",
            width: "100%;",
            disabled: true,
          },
          {
            label: "项目编号：",
            value: "constructionNo",
            type: "input",
            disabled: true,
          },
          {
            label: "招标方式：",
            value: "tenderTypeName",
            type: "input",
            disabled: true,
          },
          {
            label: "招标类别：",
            value: "tenderClassName",
            type: "input",
            disabled: true,
          },
          {
            label: "招标内容：",
            value: "tenderContent",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门名称：",
            value: "dissentDepartmentName",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门地址：",
            value: "dissentDepartmentAddress",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门联系人：",
            value: "dissentDepartmentLinkMan",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门联系人手机：",
            value: "dissentDepartmentLink",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门邮政编码：",
            value: "dissentPostalCode",
            type: "input",
            disabled: true,
          },
          {
            label: "异议受理部门电子邮箱：",
            value: "dissentDepartmentEmail",
            type: "input",
            disabled: true,
          },
          {
            label: "行政监督部门名称：",
            value: "supervisionDept",
            type: "input",
            disabled: true
          },
          {
            label: "行政监督部门地址：",
            value: "supervisionDeptAddress",
            type: "input",
            disabled: true
          },
          {
            label: "行政监督部门联系人：",
            value: "supervisionDeptLinkMan",
            type: "input",
            disabled: true
          },
          {
            label: "行政监督部门电话：",
            value: "supervisionDeptLinkPhone",
            type: "input",
            disabled: true
          },
          {
            label: "公共资源交易综合监管机构名称：",
            value: "tradingCenter",
            type: "input",
            disabled: true
          },
          {
            label: "公共资源交易综合监管机构地址：",
            value: "tradingCenterAddress",
            type: "input",
            disabled: true
          },
          {
            label: "公共资源交易综合监管机构联系人：",
            value: "tradingCenterLinkMan",
            type: "input",
            disabled: true
          },
          {
            label: "公共资源交易综合监管机构电话：",
            value: "tradingCenterLinkPhone",
            type: "input",
            disabled: true
          },
          {
            label: "房屋建筑工程面积：",
            value: "structureArea",
            type: "input",
            disabled: true
          },
          {
            label: "结构层次：",
            value: "highFloor",
            type: "input",
            disabled: true
          },
          {
            label: "地上：",
            value: "upFloor",
            type: "input",
            disabled: true
          },
          {
            label: "地下：",
            value: "underFloor",
            type: "input",
            disabled: true
          },
          {
            label: "建设地址：",
            value: "prjAddress",
            type: "input",
            width: "100%;",
            disabled: true
          },
          {
            label: "建设规模：",
            value: "prjSize",
            type: "textarea",
            disabled: true,
            width: "100%;"
          },
          {
            label: "招标范围：",
            value: "tenderContentDescription",
            type: "textarea",
            tip: "默认显示登记中招标内容说明，若需修改信息则还需填写修改原因。",
            width: "100%;",
            disabled: true
          },
          {
            label: "招标范围修改原因：",
            value: "tenderScopeUpdate",
            type: "textarea",
            width: "100%;",
            disabled: true
          },
          {
            label: "备注(注明单体工程名称、栋号)：",
            value: "remarksMonomer",
            type: "textarea",
            disabled: true,
            width: "100%;"
          },
          {
            label: "公示状态：",
            type: "select",
            value: "publicState",
            tip: "中标通知书发出前，可进行撤回操作，撤回后，可以重新发布中标公示。",
            width: "100%;",
            disabled: true,
            optionData: [
              {
                name: '正常',
                value: '0'
              },
              {
                name: '撤回',
                value: '2'
              }
            ]
          },
          {
            label: "是否需要项目负责人/总监：",
            value: "isNeedPmName",
            type: "input",
            disabled: true,
          },
          {
            label: "公示发布责任人：",
            value: "bulletinDuty",
            type: "input",
            disabled: true
          },
          {
            label: "是否有履约保证金：",
            value: "isPerformanceBondAmount",
            type: "select",
            disabled: true,
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "202304141126290004"
            },
          },
          {
            label: "履约保证金（元）：",
            value: "performanceBondAmount",
            type: "input",
            disabled: true,
            rule: []
          },
          {
            label: "是否有工程质量保证金：",
            value: "isProjectQualityDeposit",
            type: "select",
            disabled: true,
            queryParams: {
              url: "/dataDictionaryEntries/BasicDataCombobox",
              zdid: "202304141128410007"
            },
          },
          {
            label: "工程质量保证金（元）：",
            value: "projectQualityDeposit",
            type: "input",
            disabled: true,
            rule: []
          },
        ]
      },
      {
        title: "中标候选人信息",
        tip: "（前三名）",
        name: "2",
        span: 24,
        icon: "",
        formConfigList: [
          {
            label: "",
            type: "slot",
            class: "noMargin",
            width: "100%",
            slotName: "listData",
          },
        ]
      },
      {
        title: "备注",
        name: "3",
        icon: "",
        formConfigList: [
          {
            label: "备注：",
            value: "remarks",
            type: "textarea",
            tip: "（1250字以内）",
            disabled: true,
            width: "100%;"
          },
        ]
      },
      {
        title: "招标人意见",
        name: "4",
        icon: "",
        formConfigList: [
          {
            label: "招标人意见：",
            type: "textarea",
            value: "tenderOpinion",
            width: "100%;",
            disabled: true
          },
        ]
      },
    ];
  }
}
